import React, { useState, useEffect, useRef } from "react";
import UtilityHelper from "../../../service/utilities/UtilityHelper";

type TimerMinutesSecondsType = {
  className?: string;
  startStatus: boolean;
  callback?: (seconds: number) => void;
};

export const TimerMinutesSeconds: React.FC<TimerMinutesSecondsType> = ({
  className,
  startStatus = false,
  callback,
}) => {
  const [seconds, setSeconds] = useState<number>(0); // total seconds elapsed
  const [isRunning, setIsRunning] = useState<boolean>(false);
  const intervalRef = useRef<NodeJS.Timer | null>(null);

  // Effect to handle timer increment
  useEffect(() => {
    if (isRunning) {
      let counter = 0;
      intervalRef.current = setInterval(() => {
        setSeconds((prev) => prev + 1);

        counter++;
        if (typeof callback == "function") {
          callback(counter);
        }
      }, 1000);
    } else if (!isRunning && intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    // Cleanup on unmount
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
    // eslint-disable-next-line
  }, [isRunning]);

  // Helper to format seconds as MM:SS
  /* const formatTime = (sec: number) => {
    const minutes = Math.floor(sec / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (sec % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  }; */

  useEffect(() => {
    setIsRunning(startStatus);
  }, [startStatus]);

  return (
    <div
      className={
        UtilityHelper.isNotEmpty(className ?? "")
          ? className!
          : "font-gotham-book font-size-13_14 color-black"
      }
    >
      {UtilityHelper.formatTimer(seconds)}
    </div>
  );
};

/* 
 <div style={{ textAlign: "center" }}>
    <h1>{formatTime(seconds)}</h1>

    <button onClick={() => setIsRunning(true)} style={{ marginRight: 8 }}>
    Start
    </button>
    <button onClick={() => setIsRunning(false)} style={{ marginRight: 8 }}>
    Pause
    </button>
    <button onClick={() => setSeconds(0)}>Reset</button>
</div> */
